var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChemicalInjectionPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.545 291.543H70.167V387.445H247.545V291.543Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.459 202.772H136.942V211.721H181.459V202.772Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.943 207.246H123.708V216.195H193.943V207.246Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.9 386.443C207.906 386.443 247.634 346.715 247.634 297.709C247.634 248.702 207.906 208.975 158.9 208.975C109.893 208.975 70.1659 248.702 70.1659 297.709C70.1659 346.715 109.893 386.443 158.9 386.443Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.9 384.638C206.91 384.638 245.829 345.719 245.829 297.709C245.829 249.699 206.91 210.78 158.9 210.78C110.89 210.78 71.9709 249.699 71.9709 297.709C71.9709 345.719 110.89 384.638 158.9 384.638Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.655 387.445H140.146V210.862C140.146 210.862 147.275 208.449 159.006 208.449C169.534 208.449 177.655 210.862 177.655 210.862V387.445Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.924 387.445H151.08V209.354C151.08 209.354 154.282 208.75 159.549 208.75C164.277 208.75 167.924 209.354 167.924 209.354V387.445Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.813 213.988H150.979V215.994H163.813V213.988Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.702 230.632H150.979V232.638H159.702V230.632Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.813 246.473H150.979V248.479H163.813V246.473Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.813 278.359H150.979V280.365H163.813V278.359Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163.813 311.646H150.979V313.652H163.813V311.646Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M163.813 344.533H150.979V346.539H163.813V344.533Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.813 379.424H150.979V381.43H163.813V379.424Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M159.702 262.315H150.979V264.321H159.702V262.315Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M159.702 294.8H150.979V296.806H159.702V294.8Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M159.702 326.784H150.979V328.79H159.702V326.784Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M159.702 361.376H150.979V363.382H159.702V361.376Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M181.986 191.216H135.664V202.771H181.986V191.216Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M136.266 190.853C136.266 190.853 144.162 185.439 159.001 185.439C173.438 185.439 182.062 190.252 182.062 190.252V191.217H136.266V190.853Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M102.652 387.445H85.006V453.62H102.652V387.445Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64 373.208H99.795L123.256 388.046H64V373.208Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M232.996 387.445H214.948V453.62H232.996V387.445Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M214.947 412.936H102.652V420.532H214.947V412.936Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M253.8 373.208H218.006L194.544 388.046H253.8V373.208Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M181.961 191.88H135.639V202.107H181.961V191.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M141.854 190.978H139.848V203.01H141.854V190.978Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M158.251 190.978H156.245V203.01H158.251V190.978Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M174.946 190.978H172.94V203.01H174.946V190.978Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M461.934 238.999H452.934V438.481H461.934V238.999Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M517.218 238.596H396.901V76.168L517.218 76.273V238.596Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M514.21 235.588H399.909V79.176L514.21 79.277V235.588Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 72.158L403.742 69H425.399L428.457 72.158V91.258L425.399 94.266H403.742L400.684 91.258V72.158Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 77.244L428.457 77.144",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 85.8671L428.457 85.7671",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 72.158L488.869 69H510.526L513.584 72.158V91.258L510.526 94.266H488.869L485.81 91.258V72.158Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 77.244L513.584 77.144",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 85.8671L513.584 85.7671",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 72.158L460.493 69H482.15L485.209 72.158V91.258L482.15 94.266H460.493L457.435 91.258V72.158Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 77.244L485.209 77.144",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 85.8671L485.209 85.7671",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 72.158L432.117 69H453.775L456.833 72.158V91.258L453.775 94.266H432.117L429.059 91.258V72.158Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 77.244L456.833 77.144",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 85.8671L456.833 85.7671",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 98.0259L403.742 94.8679H425.399L428.457 98.0259V117.126L425.399 120.134H403.742L400.684 117.126V98.0259Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 103.112L428.457 103.012",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 111.735L428.457 111.635",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 98.0259L488.869 94.8679H510.526L513.584 98.0259V117.126L510.526 120.134H488.869L485.81 117.126V98.0259Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 103.112L513.584 103.012",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 111.735L513.584 111.635",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 98.0259L460.493 94.8679H482.15L485.209 98.0259V117.126L482.15 120.134H460.493L457.435 117.126V98.0259Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 103.112L485.209 103.012",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 111.735L485.209 111.635",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 98.0259L432.117 94.8679H453.775L456.833 98.0259V117.126L453.775 120.134H432.117L429.059 117.126V98.0259Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 103.112L456.833 103.012",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 111.735L456.833 111.635",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 149.841L403.742 146.683H425.399L428.457 149.841V168.942L425.399 171.95H403.742L400.684 168.942V149.841Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 154.926L428.457 154.827",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 163.55L428.457 163.45",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 149.841L488.869 146.683H510.526L513.584 149.841V168.942L510.526 171.95H488.869L485.81 168.942V149.841Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 154.926L513.584 154.827",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 163.55L513.584 163.45",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 149.841L460.493 146.683H482.15L485.209 149.841V168.942L482.15 171.95H460.493L457.435 168.942V149.841Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 154.926L485.209 154.827",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 163.55L485.209 163.45",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 149.841L432.117 146.683H453.775L456.833 149.841V168.942L453.775 171.95H432.117L429.059 168.942V149.841Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 154.926L456.833 154.827",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 163.55L456.833 163.45",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 186.608L403.742 183.45H425.399L428.457 186.608V205.709L425.399 208.717H403.742L400.684 205.709V186.608Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 191.694L428.457 191.594",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 200.317L428.457 200.217",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 186.608L488.869 183.45H510.526L513.584 186.608V205.709L510.526 208.717H488.869L485.81 205.709V186.608Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 191.694L513.584 191.594",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 200.317L513.584 200.217",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 186.608L460.493 183.45H482.15L485.209 186.608V205.709L482.15 208.717H460.493L457.435 205.709V186.608Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 191.694L485.209 191.594",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 200.317L485.209 200.217",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 186.608L432.117 183.45H453.775L456.833 186.608V205.709L453.775 208.717H432.117L429.059 205.709V186.608Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 191.694L456.833 191.594",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 200.317L456.833 200.217",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 123.894L403.742 120.736H425.399L428.457 123.894V142.995L425.399 146.003H403.742L400.684 142.995V123.894Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 128.98L428.457 128.88",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 137.603L428.457 137.503",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 123.894L488.869 120.736H510.526L513.584 123.894V142.995L510.526 146.003H488.869L485.81 142.995V123.894Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 128.98L513.584 128.88",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 137.603L513.584 137.503",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 123.894L460.493 120.736H482.15L485.209 123.894V142.995L482.15 146.003H460.493L457.435 142.995V123.894Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 128.98L485.209 128.88",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 137.603L485.209 137.503",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 123.894L432.117 120.736H453.775L456.833 123.894V142.995L453.775 146.003H432.117L429.059 142.995V123.894Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 128.98L456.833 128.88",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 137.603L456.833 137.503",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 212.476L403.742 209.318H425.399L428.457 212.476V231.577L425.399 234.585H403.742L400.684 231.577V212.476Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 217.562L428.457 217.462",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M400.684 226.185L428.457 226.085",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 212.476L488.869 209.318H510.526L513.584 212.476V231.577L510.526 234.585H488.869L485.81 231.577V212.476Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 217.562L513.584 217.462",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81 226.185L513.584 226.085",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 212.476L460.493 209.318H482.15L485.209 212.476V231.577L482.15 234.585H460.493L457.435 231.577V212.476Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 217.562L485.209 217.462",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M457.435 226.185L485.209 226.085",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 212.476L432.117 209.318H453.775L456.833 212.476V231.577L453.775 234.585H432.117L429.059 231.577V212.476Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 217.562L456.833 217.462",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M429.059 226.185L456.833 226.085",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M499.909 270.145H414.484V359.179H499.909V270.145Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M500.51 264.229H413.882V270.245H500.51V264.229Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M414.484 295.812H499.909",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M491.6 317.03H421.89V358.74H491.6V317.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M491.6 314.223H421.89V317.03H491.6V314.223Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M491.036 312.732H422.455V314.311H491.036V312.732Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M470.845 303.996H443.547V306.803H470.845V303.996Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M470.845 301.189H443.547V303.996H470.845V301.189Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M432.683 308.664H430.087V312.689H432.683V308.664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M432.102 308.664H429.687V310.154H432.102V308.664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M434.059 308.664H432.102V310.154H434.059V308.664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M429.687 308.664H428.711V310.154H429.687V308.664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M434.059 308.664H428.711V310.154H434.059V308.664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M436.775 311.704H425.946V312.606H436.775V311.704Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M483.793 308.446H481.197V312.471H483.793V308.446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M483.212 308.446H480.797V309.936H483.212V308.446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M485.169 308.446H483.212V309.936H485.169V308.446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M480.797 308.446H479.821V309.936H480.797V308.446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M485.169 308.446H479.821V309.936H485.169V308.446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M487.91 311.704H477.081V312.606H487.91V311.704Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M414.334 275.938H412.695V280.842H414.334V275.938Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M501.425 275.938H499.786V280.842H501.425V275.938Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M501.425 349.532H499.786V354.436H501.425V349.532Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M414.334 349.532H412.695V354.436H414.334V349.532Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M463 393.262H451.731V438.481H463V393.262Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M499.787 437.978H299.258V453.619H499.787V437.978Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M310.399 393.262V381.43H353.312V393.262H364.141V437.978H299.258V393.262H310.399Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M345.291 349.532H318.565V381.43H345.291V349.532Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M348.027 349.532H345.363V381.43H348.027V349.532Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M318.565 349.532H315.901V381.43H318.565V349.532Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M331.962 360.387C333.435 360.387 334.632 361.58 334.632 363.057C334.632 364.529 333.435 365.727 331.962 365.727C330.486 365.727 329.292 364.53 329.292 363.057C329.292 361.58 330.486 360.387 331.962 360.387Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M332.605 351.149H320.301V357.766H332.605V351.149Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M321.661 351.64C321.968 351.64 322.216 351.888 322.216 352.195C322.216 352.502 321.967 352.75 321.661 352.75C321.354 352.75 321.106 352.501 321.106 352.195C321.106 351.888 321.355 351.64 321.661 351.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M331.33 356.008C331.637 356.008 331.885 356.257 331.885 356.563C331.885 356.87 331.636 357.118 331.33 357.118C331.023 357.118 330.775 356.869 330.775 356.563C330.775 356.256 331.024 356.008 331.33 356.008Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M346.695 345.167H341.882V349.532H346.695V345.167Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M342.985 337.011H320.939V349.531H342.985V337.011Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M353.313 356.915H348.5V368.947H353.313V356.915Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M315.313 356.915H310.5V368.947H315.313V356.915Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M294.257 357.164V368.946H301.777V365.387H310.319V360.575H301.777V357.164H294.257Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M369.365 357.035V368.817H361.845V365.258H353.303V360.446H361.845V357.035H369.365Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M296.155 364.079C296.792 364.079 297.308 363.563 297.308 362.926C297.308 362.289 296.792 361.773 296.155 361.773C295.518 361.773 295.002 362.289 295.002 362.926C295.002 363.563 295.518 364.079 296.155 364.079Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M294.257 358.755H281.987V367.097H294.257V358.755Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M320.939 340.121H342.985",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M286.807 347.883H284.543V351.182H286.807V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M288.64 347.883H286.806V351.182H288.64V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M284.543 347.883H283.628V351.182H284.543V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M288.64 347.883H283.628V351.182H288.64V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M285.901 351.277H283.237V358.755H285.901V351.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M289.109 351.277H286.445V358.755H289.109V351.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M287.467 351.277H284.803V358.755H287.467V351.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M286.807 368.186H284.543V369.835H286.807V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M288.64 368.186H286.806V369.835H288.64V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M284.543 368.186H283.628V369.835H284.543V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M288.64 368.186H283.628V369.835H288.64V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M287.726 369.836H285.462V371.486H287.726V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M285.462 369.836H283.628V371.486H285.462V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M288.641 369.836H287.726V371.486H288.641V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M288.64 369.836H283.628V371.486H288.64V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M285.863 371.486H283.199V378.965H285.863V371.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M289.07 371.486H286.406V378.965H289.07V371.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M287.428 371.486H284.764V378.965H287.428V371.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M286.57 367.139H285.438V368.145H286.57V367.139Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M287.487 367.139H286.57V368.145H287.487V367.139Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M285.438 367.139H284.981V368.145H285.438V367.139Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M287.487 367.139H284.981V368.145H287.487V367.139Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M360.819 359.591H359.686V360.597H360.819V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M361.736 359.591H360.819V360.597H361.736V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M359.686 359.591H359.229V360.597H359.686V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M361.735 359.591H359.229V360.597H361.735V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M360.819 365.486H359.686V366.492H360.819V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M361.736 365.486H360.819V366.492H361.736V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M359.686 365.486H359.229V366.492H359.686V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M361.735 365.486H359.229V366.492H361.735V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M351.012 355.861H349.88V356.867H351.012V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M351.929 355.861H351.012V356.867H351.929V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M349.88 355.861H349.423V356.867H349.88V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M351.929 355.861H349.423V356.867H351.929V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M313.702 355.861H312.57V356.867H313.702V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M312.57 355.861H311.653V356.867H312.57V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M314.159 355.861H313.702V356.867H314.159V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M314.159 355.861H311.653V356.867H314.159V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M381.606 358.885H369.335V367.226H381.606V358.885Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M378.501 347.883H376.238V351.182H378.501V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M380.335 347.883H378.501V351.182H380.335V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M376.238 347.883H375.323V351.182H376.238V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M380.335 347.883H375.323V351.182H380.335V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M377.596 351.277H374.932V358.755H377.596V351.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M380.803 351.277H378.139V358.755H380.803V351.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M379.162 351.277H376.498V358.755H379.162V351.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M378.501 368.186H376.238V369.835H378.501V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M380.335 368.186H378.501V369.835H380.335V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M376.238 368.186H375.323V369.835H376.238V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M380.335 368.186H375.323V369.835H380.335V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M379.422 369.836H377.157V371.486H379.422V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M377.157 369.836H375.323V371.486H377.157V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M380.335 369.836H379.421V371.486H380.335V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M380.335 369.836H375.323V371.486H380.335V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M377.558 371.486H374.894V378.965H377.558V371.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M380.766 371.486H378.102V378.965H380.766V371.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M379.123 371.486H376.459V378.965H379.123V371.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M378.439 367.111H377.306V368.117H378.439V367.111Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M379.355 367.111H378.438V368.117H379.355V367.111Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M377.306 367.111H376.849V368.117H377.306V367.111Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M379.355 367.111H376.849V368.117H379.355V367.111Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M374.032 356.15H372.899V358.613H374.032V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M372.898 356.15H371.982V358.613H372.898V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M374.489 356.15H374.032V358.613H374.489V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M374.488 356.15H371.982V358.613H374.488V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M303.877 365.486H302.745V366.492H303.877V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M304.793 365.486H303.877V366.492H304.793V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M302.746 365.486H302.288V366.492H302.746V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M304.794 365.486H302.288V366.492H304.794V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M304.337 359.591H303.205V360.597H304.337V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M303.205 359.591H302.288V360.597H303.205V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M304.794 359.591H304.337V360.597H304.794V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M304.794 359.591H302.288V360.597H304.794V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M291.234 356.15H290.102V358.613H291.234V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M292.151 356.15H291.234V358.613H292.151V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M290.102 356.15H289.645V358.613H290.102V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M292.151 356.15H289.645V358.613H292.151V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M313.702 368.83H312.57V369.836H313.702V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M312.57 368.83H311.653V369.836H312.57V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M314.159 368.83H313.702V369.836H314.159V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M314.159 368.83H311.653V369.836H314.159V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M351.473 368.83H350.34V369.836H351.473V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M350.339 368.83H349.423V369.836H350.339V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M351.929 368.83H351.472V369.836H351.929V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M351.929 368.83H349.423V369.836H351.929V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M310.32 383.36H309.613V393.144H310.32V383.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M310.22 392.6H301.626V393.307H310.22V392.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M354.02 383.278H353.313V393.062H354.02V383.278Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M362.006 392.518H353.412V393.225H362.006V392.518Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M367.255 364.079C367.892 364.079 368.408 363.563 368.408 362.926C368.408 362.289 367.892 361.773 367.255 361.773C366.618 361.773 366.102 362.289 366.102 362.926C366.102 363.563 366.618 364.079 367.255 364.079Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M457.366 403.829C458.003 403.829 458.519 403.313 458.519 402.676C458.519 402.039 458.003 401.523 457.366 401.523C456.729 401.523 456.213 402.039 456.213 402.676C456.213 403.313 456.729 403.829 457.366 403.829Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M459.814 359.448H455.06V363.073H459.814V359.448Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M459.814 266.635H455.06V270.259H459.814V266.635Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M331.962 364.079C332.599 364.079 333.115 363.563 333.115 362.926C333.115 362.289 332.599 361.773 331.962 361.773C331.325 361.773 330.809 362.289 330.809 362.926C330.809 363.563 331.325 364.079 331.962 364.079Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73204 453.62H846.571V575.797L774.01 527.422L668.578 572.695L561.904 527.421L469.497 613.628L369.645 642.158L325.612 605.566L290.881 552.849L258.011 584.48L184.828 523.08L133.972 530.523L76.915 481.527L3.11304 462.922L3.73204 453.62Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M3.732 453.62V454.221H845.97V574.673L774.072 526.74L668.577 572.041L561.78 526.715L469.192 613.089L369.785 641.492L326.065 605.16L290.985 551.914L257.983 583.671L185.008 522.446L134.156 529.887L77.199 480.979L3.746 462.461L4.332 453.66L3.732 453.62V454.221V453.62L3.132 453.58L2.479 463.382L76.631 482.076L133.788 531.158L184.648 523.715L258.038 585.288L290.777 553.785L325.158 605.971L369.505 642.823L469.801 614.166L562.029 528.127L668.579 573.349L773.947 528.103L847.173 576.921V453.018H3.169L3.132 453.58L3.732 453.62Z",
    fill: "#384252"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M3.732 453.62V454.221H845.97V574.673L774.072 526.74L668.577 572.041L561.78 526.715L469.192 613.089L369.785 641.492L326.065 605.16L290.985 551.914L257.983 583.671L185.008 522.446L134.156 529.887L77.199 480.979L3.746 462.461L4.332 453.66L3.732 453.62ZM3.732 453.62V454.221V453.62ZM3.732 453.62L3.132 453.58L2.479 463.382L76.631 482.076L133.788 531.158L184.648 523.715L258.038 585.288L290.777 553.785L325.158 605.971L369.505 642.823L469.801 614.166L562.029 528.127L668.579 573.349L773.947 528.103L847.173 576.921V453.018H3.169L3.132 453.58L3.732 453.62Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemicalInjectionPump);
export default __webpack_public_path__ + "static/media/chemical-injection-pump.60f90e89a6ed98867a1ec95079f68d8b.svg";
export { ForwardRef as ReactComponent };